import { Button } from "../../../../../../components/ui/common/button";

interface TransportReferenceDataErrorProps {
  message: string;
  onRetry: () => void;
}

const TransportReferenceDataError = ({ message, onRetry }: TransportReferenceDataErrorProps) => (
  <div className="tw-flex tw-items-center tw-gap-3 tw-text-sm tw-text-foreground tw-py-1">
    <span>{message}</span>
    <Button type="button" variant="outline" size="sm" className="tw-h-7 tw-text-xs" onClick={onRetry}>
      Retry
    </Button>
  </div>
);

export default TransportReferenceDataError;
